import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-businessoutsourcing',
  templateUrl: './businessoutsourcing.component.html',
  styleUrls: ['./businessoutsourcing.component.css']
})
export class BusinessoutsourcingComponent implements OnInit {

  constructor(private meta: Meta, private title: Title) {
  }

  ngOnInit() {
    this.loadScripts();
    this.title.setTitle('');
  }

  loadScripts() {
    const dynamicScripts = [
      '../assets/js/anim.js'
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }

  }

}
